<div class="title"><ng-template [ngTemplateOutlet]="title"> </ng-template></div>

<div class="progress-chart">
	<div
		class="coloring"
		[@coloring]="'in'"
		(@coloring.done)="onAnimationDone()"
		[style.background]="determineColor()"
		[style.width]="getWidth()"
	>
		@if (animationDone) {
			<div class="legend"><ng-template [ngTemplateOutlet]="legend"> </ng-template></div>
		}
	</div>
</div>
